import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';


function BankIndex() {
    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    let companyid = companyId;
    if (isSuperAdmin == true && companyId == superCompanyId) {
        companyid = 0;
    }


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();

            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        setLoading(true);
        fetchData('BankApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Bank Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    }, []);


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">

            <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor'
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginTop: '-50px' }}>
                    BANK
                </h6>

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '-10px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% { box-shadow: .2em 0px 0 0px currentcolor; }
                                12% { box-shadow: .2em .2em 0 0 currentcolor; }
                                25% { box-shadow: 0 .2em 0 0px currentcolor; }
                                37% { box-shadow: -.2em .2em 0 0 currentcolor; }
                                50% { box-shadow: -.2em 0 0 0 currentcolor; }
                                62% { box-shadow: -.2em -.2em 0 0 currentcolor; }
                                75% { box-shadow: 0px -.2em 0 0 currentcolor; }
                                87% { box-shadow: .2em -.2em 0 0 currentcolor; }
                            }
                        `}</style>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                            Loading...
                        </span>
                    </div>
                )}
                <Tooltip title="Create New Bank">
                    <Button
                        style={{
                            background: 'linear-gradient(to right, #041815ff, #045157ff)',
                            marginLeft: '8px', color: 'white', fontWeight: 'bolder',
                            height: '30px', fontSize: '11px', textTransform: 'uppercase',
                            marginTop: '-2px', borderRadius: '25px'
                        }}
                        component={Link}
                        to="/BankCreate"
                        className="linkcolor"
                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                        + Add Bank
                    </Button>
                </Tooltip>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto', marginTop: '10px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        border: '1px solid #ccc', background: 'linear-gradient(to right, #051a20ff, #051a20ff)',
                                        borderRadius: '5px', textTransform: 'uppercase', borderBottom: '1px solid #ddd', fontWeight: 'bolder',
                                        fontSize: '11px', padding: '3px', color: 'white', textTransform: 'uppercase'
                                    }}>
                                    Sl.No
                                </TableCell>
                                <TableCell
                                    sx={{
                                        border: '1px solid #ccc', background: 'linear-gradient(to right, #051a20ff, #051a20ff)',
                                        borderRadius: '5px', textTransform: 'uppercase', borderBottom: '1px solid #ddd', fontWeight: 'bolder',
                                        fontSize: '11px', padding: '3px', color: 'white', textTransform: 'uppercase'
                                    }}>
                                    Bank Name
                                </TableCell>
                                <TableCell
                                    sx={{
                                        border: '1px solid #ccc', background: 'linear-gradient(to right, #051a20ff, #051a20ff)',
                                        borderRadius: '5px', textTransform: 'uppercase', borderBottom: '1px solid #ddd', fontWeight: 'bolder',
                                        fontSize: '11px', padding: '3px', color: 'white', textTransform: 'uppercase'
                                    }}>
                                    Contact No
                                </TableCell>
                                <TableCell
                                    sx={{
                                        border: '1px solid #ccc', background: 'linear-gradient(to right, #051a20ff, #051a20ff)',
                                        borderRadius: '5px', textTransform: 'uppercase', borderBottom: '1px solid #ddd', fontWeight: 'bolder',
                                        fontSize: '11px', padding: '3px', color: 'white', textTransform: 'uppercase'
                                    }}>
                                    Account Number
                                </TableCell>
                                <TableCell
                                    sx={{
                                        border: '1px solid #ccc', background: 'linear-gradient(to right, #051a20ff, #051a20ff)',
                                        borderRadius: '5px', textTransform: 'uppercase', borderBottom: '1px solid #ddd', fontWeight: 'bolder',
                                        fontSize: '11px', padding: '3px', color: 'white', textTransform: 'uppercase'
                                    }}>
                                    Ifsc Code
                                </TableCell>
                                <TableCell
                                    sx={{
                                        border: '1px solid #ccc', background: 'linear-gradient(to right, #051a20ff, #051a20ff)',
                                        borderRadius: '5px', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '11px', padding: '3px',
                                        color: 'white', textTransform: 'uppercase'
                                    }}>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((item, index) => (
                                <TableRow
                                    key={item.Id}
                                    sx={{
                                        backgroundColor: item.IsPrimary ? '#FBFBFB' : '#FBFBFB', // Primary: Greenish, Non-Primary: Reddish
                                    }}
                                >
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #ddd',
                                            //height: '10px',
                                            fontSize: '13px',
                                            padding: '1px',
                                            textAlign: 'left',
                                            fontWeight: 'bolder',

                                        }}
                                    >
                                        <span style={{ marginLeft: '20px' }}>{index + 1}</span>
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #ddd',
                                            //height: '10px',
                                            fontSize: '13px',
                                            padding: '1px',
                                            textAlign: 'left',
                                            fontWeight: 'bolder',
                                        }}
                                    >
                                        {item.Name} {item.IsPrimary ? '(Primary)' : ''}

                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #ddd',
                                            //height: '10px',
                                            fontSize: '13px',
                                            padding: '1px',
                                            textAlign: 'left',
                                            fontWeight: 'bolder',
                                        }}
                                    >
                                        {item.ContactNumber}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #ddd',
                                            //height: '10px',
                                            fontSize: '13px',
                                            padding: '1px',
                                            textAlign: 'left',
                                            fontWeight: 'bolder',
                                        }}
                                    >
                                        {item.AccountNumber}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #ddd',
                                            //height: '10px',
                                            fontSize: '13px',
                                            padding: '1px',
                                            textAlign: 'left',
                                            fontWeight: 'bolder',
                                        }}
                                    >
                                        {item.IFSCCode}
                                    </TableCell>

                                    <TableCell sx={{
                                        borderBottom: '1px solid #ddd',
                                        //height: '10px',
                                        fontSize: '13px',
                                        padding: '1px',
                                        textAlign: 'left',
                                        fontWeight: 'bolder',
                                    }}>
                                        <Link to={`/bankEdit/${item.Id}`}>
                                            <IconButton>
                                                <EditIcon style={{ color: 'red', height: '20px' }} />
                                            </IconButton>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>

            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>
        </div >

    );
}

export default BankIndex;

